import React, { useEffect, useState } from "react";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";

export const ComponentToPrint = React.forwardRef((item, ref) => {
  const { access_token } = useSelector(authSelector);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [purchaseColumn, setPurchaseColumn] = useState([]);
  const [saleColumn, setSaleColumn] = useState([]);
  const [groupedData, setGroupedData] = useState({}); // Initialize groupedData as an empty object

  // useEffect(() => {
  //   const updatedGroupedData = { 1: [], 2: [], 3: [] }; // Initialize with specific itemCodes

  //   item.item.forEach((item) => {
  //     const itemCode = Number(item.itemCode); // Ensure itemCode is a number
  //     if (updatedGroupedData[itemCode]) {
  //       updatedGroupedData[itemCode].push(item); // Push the item to the appropriate itemCode array
  //     }
  //   });

  //   // Set the state with the updated grouped data
  //   setGroupedData(updatedGroupedData);
  // }, [item.item]);

  useEffect(() => {
    const bulkSaleItem = [];
    const bulkPurchaseItem = [];

    item.item.forEach((item) => {
      console.log(item, "item");

      if (item.printOrder === 1) {
        bulkSaleItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 2) {
        bulkPurchaseItem.push(item); // UseItem push to accumulate items
      }
    });
    setSaleColumn(bulkSaleItem);
    setPurchaseColumn(bulkPurchaseItem);
    // Set the state of leftColumn and rightColumn
  }, [item.item]);

  console.log(purchaseColumn, "purchaaaaaase");

  const getName = async (e) => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };

  useEffect(() => {
    getName();
  }, []);

  // function calculateTotalPurchase(data) {
  //   const totalPurchase = data.reduce(
  //     (totalPurchase, ele) => totalPurchase + (ele.pQuantity || 0),
  //     0
  //   );
  //   return totalPurchase;
  // }

  // function calculateTotalSale(data) {
  //   const totalSale = data.reduce(
  //     (totalSale, ele) => totalSale + (ele.quantity || 0),
  //     0
  //   );
  //   return totalSale;
  // }

  const totalSaleQuantityColumn = saleColumn.reduce(
    (acc, ele) => acc + ele.quantity,
    0
  );
  const totalPurchaseQuantityColumn = purchaseColumn.reduce(
    (acc, ele) => acc + ele.pQuantity,
    0
  );

  // function calculateTotalRemaining(data) {
  //   const totalSale = data.reduce(
  //     (totalSale, ele) => totalSale + (ele.pQuantity - ele.quantity || 0),
  //     0
  //   );
  //   return totalSale;
  // }

  function getItemName(itemCode) {
    switch (
      Number(itemCode) // Ensure itemCode is treated as a number
    ) {
      case 1:
        return "Petrol";
      case 2:
        return "HSD";
      case 3:
        return "HOBC";
      default:
        return "Unknown";
    }
  }

  return (
    <div ref={ref}>
      <div className="flex flex-col items-center justify-center">
        <h1 style={{ fontSize: "30px" }}>{siteName}</h1>
        <h1 style={{ fontSize: "17px" }}>{siteAddress}</h1>
        <strong>
          <h1 style={{ fontSize: "17px" }}>Bulk Stock Report</h1>
        </strong>
      </div>
      <div className="relative mt-5 overflow-x-auto">
        <div>
          <table className="w-full text-sm text-left text-black dark:text-gray-400">
            <thead className="text-xs text-black uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr className="border-2">
                <th scope="col" className="border-r-2 w-auto">
                  SNO.
                </th>
                <th scope="col" className="border-r-2 w-auto">
                  Date
                </th>
                <th scope="col" className="border-r-2 w-auto">
                  item
                </th>
                <th scope="col" className="border-r-2 w-auto">
                  Quantity
                </th>
                {/* <th scope="col" className="border-r-2 w-2">
                  Sale Quantity
                </th>
                <th scope="col" className="border-r-2 w-2">
                  Balance Quantity
                </th> */}
                <th scope="col" className="border-r-2 w-auto">
                  Purchase Rate
                </th>
                <th scope="col" className="border-r-2 w-auto">
                  Amount
                </th>
                <th scope="col" className="border-r-2 w-auto">
                  Party Name
                </th>
                <th scope="col" className="border-r-2 w-auto">
                  Lorry
                </th>
                {/* <th scope="col" className="border-r-2 w-auto">
                  Remarks
                </th> */}
              </tr>
            </thead>
            <tbody>
              {purchaseColumn.length > 0 &&
                purchaseColumn
                  .sort((a, b) => new Date(a.enteredOn) - new Date(b.enteredOn))
                  .map((ele, i) => {
                    return (
                      <tr key={i}>
                        <td className="w-2 border-b-2 border-l-2 border-r-2">
                          {i + 1}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {new Date(ele.enteredOn).toLocaleDateString()}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.itemName}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.pQuantity}
                        </td>
                        {/* <td className="w-2 border-b-2 border-r-2">
                        {ele.quantity}
                      </td>
                      <td className="w-2 border-b-2 border-r-2">
                        {ele.pQuantity - ele.quantity}
                      </td> */}
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.purchaseRate}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.amount}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.partyName}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.lorryNo}
                        </td>
                        {/* <td className="w-auto border-b-2 border-r-2">
                        {ele.remrks}
                      </td> */}
                      </tr>
                    );
                  })}
              {/* <tr className="w-auto border-b-2">
                      <td></td>
                      <td></td>
                      <td className="w-auto">
                        {calculateTotalPurchase(groupedData[itemCode])}
                      </td>
                      <td className="w-auto">
                        {calculateTotalSale(groupedData[itemCode]).toFixed(2)}
                      </td>
                      <td>{calculateTotalRemaining(groupedData[itemCode])}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr> */}
            </tbody>
          </table>
        </div>
        <div>
          <table className="w-full text-sm text-left text-black dark:text-gray-400">
            <thead className="text-xs text-black uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr className="border-2">
                <th scope="col" className="border-r-2 w-auto">
                  SNO.
                </th>
                <th scope="col" className="border-r-2 w-auto">
                  Date
                </th>
                <th scope="col" className="border-r-2 w-auto">
                  Item
                </th>
                <th scope="col" className="border-r-2 w-auto">
                  Quantity
                </th>
                {/* <th scope="col" className="border-r-2 w-2">
                  Sale Quantity
                </th>
                <th scope="col" className="border-r-2 w-2">
                  Balance Quantity
                </th> */}
                <th scope="col" className="border-r-2 w-auto">
                  Sale Rate
                </th>
                <th scope="col" className="border-r-2 w-auto">
                  Amount
                </th>
                <th scope="col" className="border-r-2 w-auto">
                  Party Name
                </th>
                <th scope="col" className="border-r-2 w-auto">
                  Lorry
                </th>
                {/* <th scope="col" className="border-r-2 w-auto">
                  Remarks
                </th> */}
              </tr>
            </thead>
            <tbody>
              {saleColumn.length > 0 &&
                saleColumn
                  .sort((a, b) => new Date(a.enteredOn) - new Date(b.enteredOn))
                  .map((ele, i) => {
                    return (
                      <tr key={i}>
                        <td className="w-2 border-b-2 border-l-2 border-r-2">
                          {i + 1}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {new Date(ele.enteredOn).toLocaleDateString()}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.itemName}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.quantity}
                        </td>
                        {/* <td className="w-2 border-b-2 border-r-2">
                        {ele.quantity}
                      </td>
                      <td className="w-2 border-b-2 border-r-2">
                        {ele.pQuantity - ele.quantity}
                      </td> */}
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.saleRate}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.amount}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.partyName}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.lorryNo}
                        </td>
                        {/* <td className="w-auto border-b-2 border-r-2">
                        {ele.remrks}
                      </td> */}
                      </tr>
                    );
                  })}
              {/* <tr className="w-auto border-b-2">
                      <td></td>
                      <td></td>
                      <td className="w-auto">
                        {calculateTotalPurchase(groupedData[itemCode])}
                      </td>
                      <td className="w-auto">
                        {calculateTotalSale(groupedData[itemCode]).toFixed(2)}
                      </td>
                      <td>{calculateTotalRemaining(groupedData[itemCode])}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr> */}
            </tbody>
            <tbody>
              <tr className="w-auto border-b-2">
                <td></td>
                <td></td>
                <td className="w-auto">Remaining Stock</td>
                <td className="w-auto">
                  {totalPurchaseQuantityColumn - totalSaleQuantityColumn}
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* {Object.keys(groupedData).map(
          (itemCode) =>
            groupedData[itemCode].length > 0 && (
              <div key={itemCode} style={{ pageBreakAfter: "always" }}>
                <strong>Item Code {itemCode}</strong>
                <strong className="ml-2">{getItemName(itemCode)}</strong>
                <table className="w-full text-sm text-left text-black dark:text-gray-400">
                  <thead className="text-xs text-black uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr className="border-2">
                      <th scope="col" className="border-r-2 w-auto">
                        SNO.
                      </th>
                      <th scope="col" className="border-r-2 w-auto">
                        Date
                      </th>
                      <th scope="col" className="border-r-2 w-auto">
                        Purchase
                      </th>
                      <th scope="col" className="border-r-2 w-2">
                        Sale Quantity
                      </th>
                      <th scope="col" className="border-r-2 w-2">
                        Balance Quantity
                      </th>
                      <th scope="col" className="border-r-2 w-auto">
                        Sale Rate
                      </th>
                      <th scope="col" className="border-r-2 w-auto">
                        Amount
                      </th>
                      <th scope="col" className="border-r-2 w-auto">
                        Party Name
                      </th>
                      <th scope="col" className="border-r-2 w-auto">
                        Lorry
                      </th>
                      <th scope="col" className="border-r-2 w-auto">
                        Remarks
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupedData[itemCode].map((ele, i) => (
                      <tr key={i}>
                        <td className="w-2 border-b-2 border-l-2 border-r-2">
                          {i + 1}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {new Date(ele.enteredOn).toLocaleDateString()}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.pQuantity}
                        </td>
                        <td className="w-2 border-b-2 border-r-2">
                          {ele.quantity}
                        </td>
                        <td className="w-2 border-b-2 border-r-2">
                          {ele.pQuantity - ele.quantity}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.saleRate}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.amount}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.partyName}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.lorryNo}
                        </td>
                        <td className="w-auto border-b-2 border-r-2">
                          {ele.remrks}
                        </td>
                      </tr>
                    ))}
                    <tr className="w-auto border-b-2">
                      <td></td>
                      <td></td>
                      <td className="w-auto">
                        {calculateTotalPurchase(groupedData[itemCode])}
                      </td>
                      <td className="w-auto">
                        {calculateTotalSale(groupedData[itemCode]).toFixed(2)}
                      </td>
                      <td>{calculateTotalRemaining(groupedData[itemCode])}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )
        )} */}
      </div>
    </div>
  );
});
